import { doc, setDoc, getDoc, getFirestore } from "firebase/firestore"; 
import { getQuizName, getQuestionName, getModeName } from 'lib';
import { message } from "antd";
import Auth from 'auth';

const db = getFirestore();

export default class Logger {
	static init() {
		if (process.env.NODE_ENV === 'production') {
			console.error = Logger.error;
		}
	}

	static async error(msg='none', trace='none') {
		console.log('saving error logs to firestore');

		try {
			let docid;
			const auth = Auth.getAuth();
			if (auth !== undefined && auth !== null) {
				docid = auth.user.email;
			} else {
				docid = process.env.REACT_APP_ADMIN_EMAIL;
			}
			const mode = getModeName() || 'none';
			const quiz_name = getQuizName() || 'none';
			const question_name = getQuestionName() ||'none';
			const agent = navigator.userAgent;
			const log = {
				mode,
				quiz_name,
				question_name,
				agent,
				message: msg.toString(),
				trace: trace.toString(),
			}
			const time_stamp = Date();
			const data = { [time_stamp]: log };
			await setDoc(doc(db, "logs", docid), data, { merge: true });
			console.log('save successful');
		} catch (error) {
		  message.error(error.toString(), 2.5);
		  console.log(error.toString())
		}
	}
}
